import axios, {AxiosResponse} from 'axios';
const api_url = process.env.REACT_APP_STEM_API_BASE_URL+'/api'

export const GetDashboardStats=(loginid:any)=>{
   return axios.get(api_url+'/Employee/GetLandingStats?userid='+loginid);
  
  

}
   
         
       
        
